var map = {
	"./apple.png": 1099,
	"./fortnite.png": 4893,
	"./google-play.png": 6233,
	"./netflix.png": 8753,
	"./nintendo-membership.png": 1547,
	"./nintendo.png": 129,
	"./playstation.png": 2813,
	"./pubg.png": 4642,
	"./riot.png": 2290,
	"./roblox.png": 537,
	"./spotify.png": 5630,
	"./steam.png": 3260,
	"./xbox-game-pass.png": 7982,
	"./xbox.png": 7550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6768;